const {
  evaluateSource
} = require('../lib/evaluateSource');
const {
  celsiusFromFahrenheit,
  dewPoint,
  fahrenheitFromCelsius
} = require('../lib/environmental');

/**
  * @function evalute - evaluate dewPointBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const dryBulbFahrenheit = await evaluateSource(source.dryBulbSource, content, parentContentPath, transientContext, nativeFunctions);
  if (Number.isNaN(Number(dryBulbFahrenheit))) {
    return undefined;
  }
  const dryBulbCelsius = celsiusFromFahrenheit(dryBulbFahrenheit);
  const relativeHumidityValue = await evaluateSource(source.relativeHumiditySource, content, parentContentPath, transientContext, nativeFunctions);
  if (Number.isNaN(Number(relativeHumidityValue))) {
    return undefined;
  }
  const dewPointCelsius = dewPoint(dryBulbCelsius, relativeHumidityValue);
  if (Number.isNaN(Number(dewPointCelsius))) {
    return undefined;
  }
  return fahrenheitFromCelsius(dewPointCelsius);
};
module.exports = {
  evaluate
};